
const contactMe = {
    email: 'abhisheksharma131098@gmail.com',
    phone: '919518609407',
    linkedin: 'https://www.linkedin.com/in/abhisheksharma1310/',
    github: 'https://github.com/abhisheksharma1310'
};

export default contactMe;